import React from "react";
import { Combobox } from "cerulean";

const CountrySelector = ({ label, onChange, value, error, countries }: {
  label: string;
  onChange: (value: string) => void;
  value: string;
  error: string;
  countries: {name: string; code: string}[];
}) => {
  const sortAndMapCountries = () => {
    countries.sort((a, b) => {
      if (a.code === "US") return -1;
      if (b.code === "US") return 1;
      return a.name.localeCompare(b.name);
    });
    return countries.map((c) => ({
      key: c.code,
      text: c.name,
      value: c.code,
    }));
  };
  return (
    <Combobox label={label} value={value} onChange={onChange} error={error} errorText={error}>
      {Object.values(sortAndMapCountries()).map((c) => (
        <Combobox.Item key={c.key} value={c.value} searchValue={c.text}>
          {c.text}
        </Combobox.Item>
      ))}
    </Combobox>
  );
};

export default CountrySelector;
